export const STATUS_TYPES = {
  0: {
    text: '未开始',
    color: 'success'
  },
  1: {
    text: '已开始',
    color: 'warning'
  },
  2: {
    text: '已完成',
    color: 'info'
  },
  3: {
    text: '已解冻',
    color: 'primary'
  }
};
